<template lang="pug">
section.is-large
            .columns
              .column(style="text-align:left")
                p.has-text-weight-semibold.is-size-5
                    Employee(:employee="time.user")
                p.has-text-grey.is-size-6 {{date_string}}

              .column(style="text-align:left")
                p.has-text-weight-semibold.is-size-5 {{$store.state.company.name}}
                p.has-text-grey.is-size-6(v-if='task.category == "lunch"') Lunch
                p.has-text-grey.is-size-6(v-else-if='task.category == "break"') Break
                p.has-text-grey.is-size-6(v-else-if='task.category == "personal"') Personal Time
                p.has-text-grey.is-size-6(v-else-if='task.category == "travel"') Travel
                p.has-text-grey.is-size-6(v-else-if='task.category == "ga"') General Administrative
                p.has-text-grey.is-size-6(v-else) {{task.code}} {{task.name}}
            .columns
              .column(style="text-align:left")
                .field
                  label.label Start Time
                  .flex
                      .control.flex-min.margin-right
                        .select
                          select(v-model="start_hours", :disabled='readonly')
                            option(v-if="start_ampm=='AM'", :value='12') 12
                            option(v-for='hr in Array.from({length: 11}, (x,i) => i)', :value='hr+1') {{hr+1}}
                            option(v-if="start_ampm=='PM'", :value='12') 12
                            
                      .control.flex-min.margin-right
                        .select
                          select(v-model="start_mins", :disabled='readonly')
                            option(v-for='hr in Array.from({length: 12}, (x,i) => i)', :value='hr*5') {{((hr*5)+"").padStart(2, "0")}}
                      .control.flex-min.margin-right
                        .select
                          select(v-model="start_ampm", :disabled='readonly')
                            option AM
                            option PM
                .field
                  label.label Duration
                  .flex
                      .control.flex-min.margin-right
                        .select
                          select(v-model="duration_hours", :disabled='readonly')
                            option(v-for='hr in Array.from({length: 24}, (x,i) => i)', :value='hr') {{hr + " hr"}}
                      .control.flex-grow
                        .select
                          select(v-model="duration_minutes", :disabled='readonly')
                            option(v-for='hr in Array.from({length: 12}, (x,i) => i)', :value='hr*5') {{((hr*5)+"").padStart(2, "0") + " min"}}
                  section(v-if='time.overtime > 0 || time.premium > 0')
                    .regular-bg-tight
                      SecondsDisplay(v-bind:seconds='time.seconds-time.overtime-time.premium')
                    .overtime-bg-tight(v-if='time.overtime')
                      SecondsDisplay(v-bind:seconds='time.overtime')
                    .premium-bg-tight(v-if='time.premium')
                      SecondsDisplay(v-bind:seconds='time.premium')

                .field
                  .control
                    textarea.textarea(placeholder="Notes", v-model="time.notes", :disabled='readonly')     
                .field(v-if='!is_special_task')
                  label.label Craft
                  .control
                    .select
                      select(v-model='time.craft', :disabled='readonly')
                        option(v-for='craft in $store.state.crafts', :value='craft') {{craft.code + "/" + craft.level + " " + craft.description}}
              .column(style="text-align:left")
                section
                  .is-size-5.tag.is-success(v-if='time.approved') Approved
                  .is-size-5.tag.is-success.is-light(v-else-if='time.confirmed') Confirmed by employee
                  .is-size-5.tag.is-info.is-light(v-else) Unconfirmed
                div(v-if='!is_special_task')
                 section(v-if="time.category != 'equipment'")
                  .field
                    label.label Equipment
                    AddonPicker(:addons="$store.state.equipment", v-on:added="attach_equipment", :readonly='readonly')
                      .control.flex-min
                        button.button.is-info
                          font-awesome-icon(icon="plus")
                  ul.list
                    li.list-item(v-for="mc in time.equipment_usage")
                      .flex
                        .flex-grow 
                          label {{mc.equipment.code}} {{mc.equipment.name}}
                        .flex-min(v-if="!readonly"): button.button.is-small.is-danger(@click="remove_equipment(mc)")
                          font-awesome-icon(icon="trash-alt")
                      //-.flex
                        .flex-shrink(style="margin-right:0.5rem")
                          .field
                            .control
                              p Seconds control
                        .flex-grow: label {{mc.uom}}
                  
                 
                 section(v-if="time.category == 'workorder'")
                  .field
                    label.label Service Codes
                    AddonPicker(:addons="$store.state.service_codes", v-on:added="attach_service_code", :readonly='readonly')
                  ul.list
                    li.list-item(v-for="mc in time.service_codes")
                      .flex
                        .flex-grow {{mc.code}} {{mc.name}}
                        .flex-min(v-if="!readonly"): button.button.is-small.is-danger(@click="remove_service_code(mc)", :disabled='readonly')
                          font-awesome-icon(icon="trash-alt")
                  
                 section(v-if="time.category == 'equipment'")
                  .field
                    label.label Maintenance Codes
                    AddonPicker(:addons="$store.state.maintenance_codes", v-on:added="attach_maintenance_code", :readonly='readonly')
                  ul.list
                    li.list-item(v-for="mc in time.maintenance_codes")
                      .flex
                        .flex-grow {{mc.code}} {{mc.name}}
                        .flex-min(v-if="!readonly"): button.button.is-small.is-danger(@click="remove_maintenance_code(mc)", :disabled='readonly')
                          font-awesome-icon(icon="trash-alt")
                  
                 section
                  .field
                    label.label Materials
                    AddonPicker(:addons="$store.state.materials", v-on:added="attach_material", :readonly='readonly')
                  ul.list
                    li.list-item(v-for="mc in time.material_usage")
                      .flex
                        .flex-grow 
                          label {{mc.material.code}} {{mc.material.name}}
                        .flex-min(v-if="!readonly"): button.button.is-small.is-danger(@click="remove_material(mc.material)", :disabled='readonly')
                          font-awesome-icon(icon="trash-alt")
                      .flex
                        .flex-shrink(style="margin-right:0.5rem")
                          .field
                            .control
                              input.input(v-model='mc.units', type="number", :disabled='readonly')
                        .flex-grow: label {{mc.material.uom}}
                
                 section
                  .field
                    label.label Pay Codes
                    AddonPicker(:addons="$store.state.paycodes", v-on:added="attach_paycode", :readonly='readonly')
                  ul.list
                    li.list-item(v-for="mc in time.paycodes")
                      .flex
                        .flex-grow 
                          label {{mc.code.code}} {{mc.code.name}}
                        .flex-min(v-if="!readonly"): button.button.is-small.is-danger(@click="remove_paycode(mc.code)", :disabled='readonly')
                          font-awesome-icon(icon="trash-alt")
                      .flex(v-if="mc.code.display_quantity")
                        .flex-shrink(style="margin-right:0.5rem")
                          .field
                            .control
                              input.input(type="number", v-model="mc.units", :disabled='readonly')
                        .flex-grow: label {{mc.code.uom}}
                div(v-else-if='is_linked') 
                  .field(style="margin-top:1em")
                    label.label Linked Task
                    .control.flex-min.margin-right
                        .select
                          select(:disabled='readonly', @change="update_linked_task($event)")
                            option(:selected='task._id == (time.linked_task ? time.linked_task._id : 1)', v-for='task in $store.state.tasks.filter(t => t._id)', :key='task._id' :value='task._id') 
                              span.margin-right {{task.code}}  
                              span(v-if='task.phaseCode').phaseCode.margin-right {{task.phaseCode}} 
                              span(v-if='task.phaseCode && task.costCode').margin-right | 
                              span(v-if='task.costCode').margin-right.costCode {{task.costCode}} 
                              span(v-if='(task.phaseCode || task.costCode) && task.changeOrder').margin-right | 
                              span(v-if='task.changeOrder').margin-right ({{task.changeOrder}}) 
                              span(v-if='task.phaseCode || task.costCode').margin-right - 
                              span {{task.name}}
                    
                    
</template>

<script>
import moment from "moment";
import AddonPicker from "@/components/AddonPicker";
import Employee from "@/components/Employee";
import SecondsDisplay from "@/components/SecondsDisplay";

export default {
  name: "TimeLog",
  components: {
    AddonPicker,
    Employee,
    SecondsDisplay
  },

  computed: {
    task: function() {
      if (this.time && this.time.task) {
        return this.time.task;
      } else {
        if (this.time.category == "equipment") {
          return this.time.equipment;
        } else if (this.time.category == "line-item") {
          return this.time.lineItem;
        } else if (this.time.category == "workorder") {
          return this.time.workorder;
        } else {
          return { category: this.time.category };
        }
      }
    },
    is_special_task() {
      switch (this.task.category) {
        case "lunch":
        case "ga":
        case "personal":
        case "break":
        case "travel":
          return true;
        default:
          return false;
      }
    },
    is_linked() {
      switch (this.task.category) {
        case "lunch":
        case "break":
        case "travel":
          return true;
        default:
          return false;
      }
    },
    readonly() {
      return this.time.approved;
    },
    duration_hours: {
      get() {
        const hr = this.time.seconds
          ? Math.floor(this.time.seconds / 60 / 60)
          : 0;
        return hr;
      },
      set(value) {
        const minutes =
          ((this.time.seconds ? Math.floor(this.time.seconds / 60) : 0) % 60) +
          value * 60;
        this.time.seconds = minutes * 60;
      }
    },
    duration_minutes: {
      get() {
        const minutes = this.time.seconds
          ? Math.floor(this.time.seconds / 60)
          : 0;
        return minutes % 60;
      },
      set(value) {
        const hours = this.time.seconds
          ? Math.floor(this.time.seconds / 60 / 60)
          : 0;
        const minutes = hours * 60 + value;
        this.time.seconds = minutes * 60;
      }
    },
    start_hours: {
      get() {
        const hr = moment(this.time.start).hours();
        if (this.start_ampm == "AM") {
          if (hr == 0) return 12;
          else {
            return hr;
          }
        } else {
          if (hr == 12) return 12;
          else return hr - 12;
        }
      },
      set(value) {
        let hr = value;
        if (this.start_ampm == "AM") {
          if (value == 12) hr = 0;
        } else {
          if (value == 12) hr = 12;
          else hr = value + 12;
        }
        const new_m = moment(this.time.start).hours(hr);
        this.time.start = new_m.toDate();
      }
    },
    start_mins: {
      get() {
        return moment(this.time.start).minutes();
      },
      set(value) {
        const m = moment(this.time.start).minutes(value);
        this.time.start = m.toDate();
      }
    },
    start_ampm: {
      get() {
        const hr = moment(this.time.start).hours();
        if (hr < 12) return "AM";
        else return "PM";
      },
      set(value) {
        const hr = moment(this.time.start).hours();
        if (hr < 12) {
          if (value == "PM") {
            // Currently in AM, and setting to PM - increment hours.
            const new_m = moment(this.time.start).hours(hr + 12);
            this.time.start = new_m.toDate();
          }
        } else {
          if (value == "AM") {
            // Currently in PM, and setting to AM, decrement hours.
            const new_m = moment(this.time.start).hours(hr - 12);
            this.time.start = new_m.toDate();
          }
        }
      }
    },
    date_string: function() {
      return moment(this.time.start).format("MMM DD, YYYY");
    }
  },

  props: ["time"],
  mounted: function() {},
  watch: {
    "time.start": function() {
      this.time.startTime = moment(this.time.start).format("HH:mm");
    }
  },
  methods: {
    moment: function() {
      return moment();
    },
    update_linked_task(task) {
      const ts = this.$store.state.tasks.filter(
        t => t._id == task.target.value
      );
      this.time.linked_task = ts.length ? ts[0] : undefined;
    },
    attach_material(material) {
      if (!material) return;
      this.time.material_usage.push({
        material: material,
        units: 1
      });
    },
    remove_material(material) {
      this.time.material_usage = this.time.materials.filter(
        mc => mc.material._id != material._id
      );
    },
    attach_equipment(equipment) {
      if (!equipment) return;
      this.time.equipment_usage.push({
        equipment: equipment,
        seconds: 0,
        sync_with_task: true
      });
    },
    remove_equipment(equipment) {
      this.time.equipment_usage = this.time.equipment_usage.filter(
        mc => mc.equipment._id != equipment.equipment._id
      );
    },
    attach_paycode(code) {
      if (!code) return;
      this.time.paycodes.push({
        code: code,
        units: 1
      });
    },
    remove_paycode(code) {
      this.time.paycodes = this.time.paycodes.filter(
        mc => mc.code._id != code._id
      );
    },
    attach_service_code(code) {
      if (!code) return;
      this.time.service_codes.push(code);
    },
    remove_service_code(code) {
      this.time.service_codes = this.time.service_codes.filter(
        mc => mc._id != code._id
      );
    },
    attach_maintenance_code(code) {
      if (!code) return;
      this.time.maintenance_codes.push(code);
    },
    remove_maintenance_code(code) {
      this.time.maintenance_codes = this.time.maintenance_codes.filter(
        mc => mc._id != code._id
      );
    }
  }
};
</script>

<style scoped lang="less">
.time-bg-tight {
  text-align: center;
  margin-top: 2px;
  border-radius: 2px;
  padding: 3px;
}
.regular-bg-tight {
  background: #bfeacb;
  .time-bg-tight;
}

.overtime-bg-tight {
  background: #f8ffd0;
  .time-bg-tight;
}

.premium-bg-tight {
  background: #ffd0d0;
  .time-bg-tight;
}
</style>
